// extracted by mini-css-extract-plugin
export var cell = "_6c-4";
export var headerCell = "_6c-2";
export var rowHeader = "_6c-3";
export var table = "_6c-1";
export var tableContainer = "_6c-0";